import { render, staticRenderFns } from "./ComprometimentoCancelarEnvioParaAnalise.vue?vue&type=template&id=4197904c"
import script from "./ComprometimentoCancelarEnvioParaAnalise.vue?vue&type=script&lang=js"
export * from "./ComprometimentoCancelarEnvioParaAnalise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports